








































































































































































import {myVue} from "@/components/class/myVue";
import {Component} from 'vue-property-decorator';
import * as utils from "@/components/util/utils";

@Component
export default class HelloWorld extends myVue {
  data() {
    return {
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],
    }
  }

  flitterData(arr: any) {
    let spanOneArr: any = []
    let concatOne = 0
    arr.forEach((item: any, index: any) => {
      if (index === 0) {
        spanOneArr.push(1)
      } else {
        //name 修改
        if (item.id === arr[index - 1].id) { //第一列需合并相同内容的判断条件
          spanOneArr[concatOne] += 1
          spanOneArr.push(0)
        } else {
          spanOneArr.push(1)
          concatOne = index
        }
      }
    })
    return {
      one: spanOneArr,
    }
  }

  objectSpanMethod({row, column, rowIndex, columnIndex}: any) {
    if (columnIndex === 3 || columnIndex === 2 || columnIndex === 1) {
      // this.tableData  修改
      const _row = (this.flitterData(this.current.value).one)[rowIndex]
      const _col = _row > 0 ? 1 : 0;
      return {
        rowspan: _row,
        colspan: _col
      }
    }
  }

  myBtnList(data: any) {
    let list = []
    for (let i = 0; i < this.current.tableBtn.length; i++) {
      let item = this.current.tableBtn[i];
      let bool = utils.isJurisdiction({
        process: item.process,
        jurisdictionList: item.jurisdictionJson,
        data: {row: data.row}
      })
      if (bool) {
        list.push(item)
      }
    }
    return list
  }

  myBtnOne(data: any) {
    let list = this.myBtnList(data);
    if (list.length > 0) {
      return list[0]
    } else {
      return {}
    }
  }

  myShowSummary(param: any) {
    return this.current.summaryData(param)
  }

  row_style({row, rowIndex}: any) {
    return this.current.row_style({row, rowIndex, that: this.current})
  }

  cell_style({row, column, rowIndex, columnIndex}: any) {
    if (columnIndex === 6) {
      if (row.seal_num > 0) {
        return {'background-color': "#FCDAD5"};
      }
    }else if (columnIndex === 7) {
      if (row.assembly_num > 0) {
        return {'background-color': "#FCDAD5"};
      }
    } else if (columnIndex === 8) {
      if (row.process_num > 0) {
        return {'background-color': "#FCDAD5"};
      }
    }
  }

  handleSizeChange(val: any) {
    this.current.rows = val
    this.reQuery("content")
  }

  handleCurrentChange(val: any) {
    this.current.currentPage = val
    this.reQuery("content")
  }

  sortChange(a: any, b: any, c: any) {
  }

  selectionChange(selection: any) {
    this.current.selectRow = selection
  }

  rowClick(row: any, b: any, c: any) {
    this.current.selectRowOnly = row
    this.current.rowClick({row: row})
  }

  cellClick(row: any, column: any, cell: any, event: any, data: any) {
    this.current.selectRowOnly = row
    let power = this.current.components.content
    for (let i = 0; i < this.current.components.content.length; i++) {
      let item = this.current.components.content[i];
      if(column.label == item.label){
        let bool = this.jurisdictionJson({jurisdictionList: item.jurisdictionJson})
        if(bool){
          this.current.cellClick({lie: column.label, factory_id: row.factory_id, number_id: row.id,power:power})
        }
      }
    }
  }

  cellMouseEnter(a: any, b: any, c: any) {
  }

  public_click(data: any) {
    this.current.selectRowOnly = data.row
    data.item.click({row: data.row})
  }

  public_click2(data: any) {
    this.current.selectRowOnly = data.row
    data.item.click()
  }
}

